// Client for the Aivio website chat (app/routers/aivio_chat_api.py on the Aivio API, under /api/aivio).
// The watsonx Orchestrate key stays on that server; this file only knows its URL.
export const CHAT_API = (process.env.REACT_APP_AIVIO_CHAT_API || `${process.env.REACT_APP_API_URL || ""}aivio`).replace(/\/+$/, "");

const OPEN_EVENT = "aivio:open-chat";

// Open the chat widget from anywhere on the site, optionally asking a question straight away.
export function openAivioChat(prompt) {
  window.dispatchEvent(new CustomEvent(OPEN_EVENT, { detail: { prompt } }));
}

export function onOpenAivioChat(handler) {
  const listener = (event) => handler(event.detail?.prompt);
  window.addEventListener(OPEN_EVENT, listener);
  return () => window.removeEventListener(OPEN_EVENT, listener);
}

export const isRegisteredVisitor = () => sessionStorage.getItem("token") === "loggedIn";

// Document links from the API are either absolute or relative to the API (/doc?u=...).
export function resolveHref(href) {
  if (!href) return "";
  if (href.startsWith("/")) return CHAT_API + href;
  return /^https?:\/\//i.test(href) ? href : "";
}

/**
 * POST /chat/stream and call onEvent for every NDJSON line:
 * {t}, {replace, clear_refs}, {status}, {refs}, {thread_id}, {done}.
 */
export async function streamChat({ message, threadId, signal, onEvent }) {
  const res = await fetch(`${CHAT_API}/chat/stream`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ message, thread_id: threadId || undefined, registered: isRegisteredVisitor() }),
    signal,
  });
  if (!res.ok || !res.body) throw new Error(`Chat unavailable (${res.status})`);

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  const handleLine = (line) => {
    if (!line.trim()) return;
    try {
      onEvent(JSON.parse(line));
    } catch {
      // Ignore a malformed line rather than dropping the whole answer.
    }
  };
  for (;;) {
    const { value, done } = await reader.read();
    if (done) {
      buffer += decoder.decode();
      handleLine(buffer);
      return;
    }
    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split("\n");
    buffer = lines.pop();
    lines.forEach(handleLine);
  }
}
